<script setup lang="ts">
import type { BaseItem } from '~/models/Content/BaseItem'
import { computed } from 'vue'
import { faArrowLeft, faArrowRight } from '@fortawesome/duotone-regular-svg-icons'
import { PendoFeature } from '~/models/Pendo'
import { useUrlBuilder } from '~/composables/useUrlBuilder'
import { useStaticProduct } from '~/composables/useStaticProduct'
import useDescriptor from '~/composables/useDescriptor'
import { useContentHelper } from '~/composables/useContentHelper'

const { item, direction } = defineProps<{
  item?: BaseItem
  hasTaskLocationIds?: boolean
  direction: 'previous' | 'next'
}>()

const icon = {
  previous: faArrowLeft,
  next: faArrowRight
}[direction]

const { buildResourceUrl } = useUrlBuilder()
const { getDescriptor } = useDescriptor()
const { Terminprover } = useStaticProduct()
const { getTitle } = useContentHelper()

const href = computed(() => item ? buildResourceUrl(item) : null)

const tracking = computed(() => item && item.pathString.startsWith(Terminprover.aunivers.pathString!)
  ? { 'data-pendo': PendoFeature.TermExam.NavigateTask }
  : {}
)
</script>

<template>
  <router-link
    v-if="item && href"
    :to="{ path: href }"
    class="m-2 flex w-fit max-w-full flex-1 flex-col gap-2 rounded-lg p-4 text-(--theme-60) transition hover:bg-(--theme-60) hover:text-(--theme-10) focus-visible:ring md:m-4"
    :class="direction === 'next' ? 'text-right ml-auto!' : 'mr-auto!'"
    v-bind="tracking"
  >
    <div
      class="text-xs font-semibold text-(--card-accent) uppercase"
      v-text="hasTaskLocationIds ? item.parentLocationName : getDescriptor(item)"
    />
    <h3
      class="overflow-hidden font-semibold overflow-ellipsis whitespace-nowrap md:text-lg"
      v-text="getTitle(item)"
    />
    <font-awesome-icon :icon :class="{ 'self-end': direction === 'next' }" />
  </router-link>
  <div v-else />
</template>
